<!-- eslint-disable max-lines -->
<template>
    <paper class="dispatch">
        <div v-if="isDetail">
            <el-button @click="back">返 回</el-button>
            <el-tabs v-model="activeName" type="card">
                <el-tab-pane label="运输单信息" name="info">
                    <el-table :data="infoData" border style="width: 100%">
                        <el-table-column
                            v-for="item in infoTableColumn"
                            :key="item.prop" :prop="item.prop" :label="item.label" width="180">
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="商品明细" name="inventory">
                    <el-table :data="inventoryData" border style="width: 100%">
                        <el-table-column v-for="item in inventoryTableColumn" :key="item.prop"
                            :prop="item.prop" :label="item.label" width="180">
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </div>
        <m-pane
            ref="tablePage" v-else class="tablePage"
            :config="config" :totalData="totalData" :initSearchInfo="initSearchInfo"
            :pageTotal="pageTotal" :loading="loading" :currentPage="currentPage"
            @pageChange="pageChange" @sizeChange="sizeChange" @searchChange="searchChange"
            @selectChange="selectChange" @row-db-click="rowDBclick" @edit-btn="editBtn" @toTheCar-btn="toTheCar"
            @abnormalReason-btn="abnormalReason"
            :searchTotalTitle="config.searchTotalTitle"
            searchId="test" pageID="test">
            <div slot="table-module-btn">
                <reportExport #default="{ submit }" reportCode="REPORT-LSP-LMS-DISPATCH">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="'05030005'"><el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button></span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <el-button type="primary" @click="depart" v-has="'05030001'">发车确认</el-button>
                <el-dropdown style="margin-left: 10px;" v-has="'05030002'">
                    <span>
                        <el-button type="primary">打印
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="print('delivery_order')">提货单</el-dropdown-item>
                        <el-dropdown-item @click.native="print('distribution_order')">配送单</el-dropdown-item>
                        <!-- <el-dropdown-item @click.native="print('transport_label')">运输标签</el-dropdown-item>
                        <el-dropdown-item @click.native="print('centralized_assembling_order')">集配单</el-dropdown-item>
                        <el-dropdown-item @click.native="print('report_consignment_invoice')">送货清单</el-dropdown-item>
                        <el-dropdown-item @click.native="print('new_sale_print')">新销司打印</el-dropdown-item>
                        <el-dropdown-item @click.native="print('new_els_print')">电商配送清单</el-dropdown-item> -->
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button type="primary" @click="handleRegistration" v-has="''" style="margin-left: 10px;">整车异常发车原因</el-button>
            </div>
        </m-pane>
        <el-dialog title="编辑" :visible.sync="editVisible" width="80%" @close="handleEditClose">
            <el-form ref="form"
                inline
                :model="ruleForm"
                label-position="right"
                label-width="100px"
                :rules="rules">
                <el-row :gutter="10">
                    <el-col :span="6">
                        <el-form-item label="发车单号">
                            <el-input v-model="ruleForm.etdoNo" disabled style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="服务平台">
                            <el-input v-model="ruleForm.siteName" disabled style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="发车单状态">
                            <otpSelect
                                style="width: 180px"
                                disabled
                                :optionNum="'SYS_TRANSPORT_DO_STATUS'"
                                :mValue="ruleForm.etdoStatus"
                                :prop="'etdoStatus'"
                            ></otpSelect>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="承运商">
                            <el-input v-model="ruleForm.etdoCarrierName" disabled style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="车牌号" prop="etdoVehicleCard">
                            <otpAdvance
                                :disabled="abledEtdoVehicleCard"
                                style="width: 180px"
                                :mValue="ruleForm.etdoVehicleCard"
                                @getAdvanceValue="getAdvanceValue"
                                :params="config.viewBillBasicData.carNumber"
                                :formData="formData"
                            ></otpAdvance>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="车型">
                            <el-input v-model="ruleForm.etdoEquipmentName" disabled style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="司机" prop="etdoMainDriver">
                            <otpAdvance
                                style="width: 180px"
                                :disabled="abledEtdoMainDriver"
                                :mValue="ruleForm.etdoMainDriver"
                                @getAdvanceValue="getAdvanceValue"
                                :params="config.viewBillBasicData.driverLists"
                                :formData="formData"
                            ></otpAdvance>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="联系方式" prop="etdoMainDriverContactWay">
                            <!-- <el-input v-model="ruleForm.etdoMainDriverContactWay" :disabled="abledEtdoMainDriverContactWay" style="width: 180px"></el-input> -->
                            <el-input v-model="ruleForm.etdoMainDriverContactWay" disabled style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="要求到车时间" prop="etdoBesArriveDate">
                            <el-date-picker
                                style="width: 180px"
                                :disabled="abledEtdoBesArriveDate"
                                v-model="ruleForm.etdoBesArriveDate"
                                type="datetime"
                                placeholder="预计到车时间"
                                default-time="23:59:59"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="调度人员">
                            <el-input v-model="ruleForm.etdoDispatcherName" disabled style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="备注">
                            <el-input v-model="ruleForm.etdoRemark" disabled style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="总费用(元)">
                            <el-input v-model="ruleForm.etdoTotalFee" disabled style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="() => {this.handleEditClose()}">取 消</el-button>
                <el-button type="primary" @click="handleEditChange" :loading="saveLoading">保 存</el-button>
            </span>
        </el-dialog>
        <!-- 整车异常发车原因弹窗 -->
        <register-reason-dialog
            v-if="registerVisible"
            :registerVisible.sync="registerVisible"
            :componentsData="componentsData"
            @update="update">
        </register-reason-dialog>
        <!-- 电子围栏校验提示和备注 -->
        <dispatch-handle-reason
            v-if="isShowHandleReasonDialog"
            ref="dispatchHandleReason"
            :isShowHandleReasonDialog.sync="isShowHandleReasonDialog"
            :componentsData="componentsData"
            :handleType="handleType"
            @handleSuccess="handleSuccess"
            @closeFenceDialog="closeFenceDialog"
        ></dispatch-handle-reason>
        <!-- 电子围栏校验提示和备注 -->
    </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import mPane from '@/components/supplierPanel';
import config from './config.js';
import { info, inventory } from './tableColumn';
import otpSelect from '@/components/lots/otpSelect';
import otpAdvance from '@/components/lots/otpAdvance';
import reportExport from '@/components/lots/reportExportPlugin';
import configs from '@/config/user.env';
import { maxDay } from '@/modules/transport/tms/common/common';
import {
    getList, departConfirmBefore, departConfirm, vehicleInformationQuery, saveItem,
    asternConfirm2, asternConfirmOne, getControlParamStringValue, getCarTypeApi, checkCarNameNetItemApi,
    departCheckOperateReason, arriveCheckOperateReason
} from '../../api/dispatchOrder';
import dayjs from 'dayjs';
import common from '../../common/common';
import { mapGetters } from 'vuex';
import registerReasonDialog from './components/dispatchAbnormalReason/Index';
import DispatchHandleReason from './components/dispatchHandleReason/Index';
import { isValidate } from './components/dispatchAbnormalReason/util.js';
import { joinPath } from '@/utils/url';
const { getSessionKey, initSessionData } = common;
const userId = 150;
const etdoPickUpType = '6';
const ConstantsTES = {
    DO_STATUS_CALL_CAR: '10',
    DO_STATUS_IN_THE_CAR: '20',
    DO_STATUS_LOADING: '25',
    TMS_EXPRESS: '50' // 采购渠道-快递
};
const defaultValue = 5021910428;
export default {
    name: 'tmsDispatchOrder',
    components: { paper, mPane, otpSelect, otpAdvance, reportExport, registerReasonDialog, DispatchHandleReason },
    created() {
        this.initRouter();
    },
    activated() {
        this.initRouter(true);
    },
    mounted() {
        this._getControlParamStringValue();
        initSessionData(['SYS_YES_NO', 'SYS_MY_TMS_PROCUREMENT_CHANNEL', 'SYS_WHOLE_EXCEPTION_TYPE', 'LSP_SHIPPING_TYPE']);
    },
    computed: {
        ...mapGetters(['supplier', 'currentTenant'])
    },
    data() {
        return {
            formData: { supplierCode: '', routeNoList: [] },
            config,
            initSearchInfo: {}, // 用于设置初始默认值
            totalData: [], // table数据
            pageTotal: 0, // 总条数
            loading: false, // table的loading状态
            currentPage: 1, // 当前页数
            pageSize: 10, // 每页数量
            searchData: {}, // 搜索的对象结果
            selectArray: [], // 选中的集合
            departloading: false, // 发车单按钮loading
            isDetail: false, // 双击的详情页
            activeName: 'info', // tabs页
            infoData: [], // 运输单信息table
            inventoryData: [], // 商品明细table
            infoTableColumn: info, // 运输单信息column
            inventoryTableColumn: inventory, // 商品明细column
            editVisible: false, // 编辑弹窗
            saveLoading: false, // 弹窗loading
            abledEtdoVehicleCard: false, // 车牌号码禁用状态
            abledEtdoMainDriver: false, // 司机禁用状态
            abledEtdoBesArriveDate: false, // 要求到车时间禁用状态
            // abledEtdoMainDriverContactWay: false, // 联系方式禁用状态
            ruleForm: {
                etdoNo: '', // 发车单号
                siteName: '', // 服务平台
                etdoStatus: '', // 发车单状态
                etdoCarrierName: '', // 承运商
                etdoVehicleCard: '', // 车牌号
                etdoEquipmentName: '', // 车型
                etdoMainDriver: '', // 司机
                etdoMainDriverContactWay: '', // 联系方式
                etdoBesArriveDate: '', // 要求到车时间
                etdoDispatcherName: '', // 调度人员
                etdoRemark: '', // 备注
                etdoTotalFee: '' // 总费用
            },
            rules: {
                etdoVehicleCard: [
                    { required: true, message: '请输入车牌号', trigger: 'change' }
                ],
                etdoMainDriver: [
                    { required: true, message: '请输入司机', trigger: 'change' }
                ],
                etdoMainDriverContactWay: [
                    { required: true, message: '请输入联系方式', trigger: 'change' }
                ],
                etdoBesArriveDate: [
                    { required: true, message: '请选择要求到车时间', trigger: 'change' }
                ]
            },
            exportParams: {},
            isFirstSearch: true,
            controlParams: '', // 控制参数用于校验打印
            registerVisible: false, // 登记异常原因弹窗
            rowData: {},
            isShowHandleReasonDialog: false, // 是否显示围栏校验提示
            handleType: 'depart' // 操作类型：发车
        };
    },
    methods: {
        _validateSearchParams(data) {
            if (!data.createTimeFrom) {
                return '创建日期不能为空！';
            }
            const beginDate = dayjs(data.createTimeFrom).valueOf() || 0;
            const endDate = dayjs(data.createTimeTo).valueOf() || 0;
            const differenceValue = endDate - beginDate;
            if (differenceValue > maxDay) {
                return '按时间查询或导出时，时间跨度不可超过一个月！';
            }
        },
        // 列表请求
        _getList(pageNo = 1) {
            const msg = this._validateSearchParams(this.searchData);
            if (msg) return this.$message.warning(msg);
            this.loading = true;
            const {
                SYS_TRANSPORT_DO_STATUS,
                SYS_YES_NO,
                SYS_MY_TMS_PROCUREMENT_CHANNEL,
                SYS_WHOLE_EXCEPTION_TYPE,
                LSP_SHIPPING_TYPE
            } = sessionStorage;
            this.exportParams = { etdoCarrierCode: this.supplier.supplierCode, ...this.exportParams };
            getList({
                pageNo,
                pageSize: this.pageSize,
                etdoCarrierCode: this.supplier.supplierCode,
                ...this.searchData
            }).then((res) => {
                if (res && res.data && +res.code === 0) {
                    const { list, totalCount, pageNo } = res.data;
                    this.totalData = list.map(item => {
                        // 发车单状态
                        item.etdoStatusType = getSessionKey(item.etdoStatus, SYS_TRANSPORT_DO_STATUS);
                        // 是否有分拨
                        item.allotNumType = getSessionKey(item.allotNum, SYS_YES_NO);
                        // 采购渠道
                        item.etdoProcurementChannelType = getSessionKey(item.etdoProcurementChannel, SYS_MY_TMS_PROCUREMENT_CHANNEL);
                        // 直通宝标识
                        // item.etdoLtlFlagType = getSessionKey(item.etdoLtlFlag, SYS_TMS_ZTB_FLAG);
                        // 异常发车原因
                        item.wholeExceptionTypeName = getSessionKey(item.wholeExceptionType, SYS_WHOLE_EXCEPTION_TYPE);
                        // 发运类型
                        item.shippingTypeName = getSessionKey(item.shippingType, LSP_SHIPPING_TYPE);
                        return item;
                    });
                    this.pageTotal = totalCount;
                    this.currentPage = +pageNo;
                }
                this.loading = false;
            });
        },
        exportFile(submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            if (!this.isFirstSearch) {
                const msg = this._validateSearchParams(this.searchData);
                if (msg) return this.$message.warning(msg);
            }
            submit({ ...this.exportParams, carrierCode: this.supplier.supplierCode, tenantCode: this.currentTenant.tenantCode });
            this.isFirstSearch = false;
        },
        // 发车确认前校验
        _departConfirmBefore() {
            this.departloading = true;
            departConfirmBefore(this.selectArray).then(res => {
                if (res && +res.code === 0 && res.data) {
                    if (res.data.success) {
                        this._departConfirm();
                    } else {
                        this.$confirm(res.data.messages, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning',
                            center: true
                        }).then(() => {
                            this._departConfirm();
                        });
                    }
                } else {
                    this.$message.error(res.data.messagesAsString);
                }
            });
        },
        // 确认发车发车确认
        _departConfirm() {
            departConfirm(this.selectArray).then(res => {
                if (res) {
                    if (res.data.success) {
                        if (res.data.messagesAsString.length !== 0) {
                            this.$message({
                                message: res.data.messagesAsString,
                                type: 'warning',
                                offset: 100
                            });
                        }
                        this.$message.success('确认成功!');
                        this.$refs.tablePage.$refs.searchList.onSearchChange();
                    } else {
                        this.$message.error(res.data.messagesAsString);
                    }
                } else {
                    this.$message.error(res.msg);
                }
                this.departloading = false;
            });
        },
        // 校验参数
        _getControlParamStringValue() {
            getControlParamStringValue({
                key: 'SYS_TMS_LSP_COMPANY',
                defaultValue
            }).then(res => {
                if (res && +res.code === 0) {
                    this.controlParams = res.data;
                }
            });
        },
        _asternConfirm2(row) {
            asternConfirm2({
                models: [row],
                pickUpModel: {
                    etdoPickUpCarNo: row.etdoVehicleCard,
                    etdoPickUpCarNoSel: row.etdoVehicleCard,
                    siteCode: row.siteCode,
                    etdoPickUpPerson: userId,
                    etdoPickUpThePhone: row.etdoMainDriverContactWay,
                    ettaOutWhCode: row.ettaOutWhCode,
                    etdoPickUpType
                },
                userId
            }).then(res => {
                if (res) {
                    if (res.data.success) {
                        this.$message.success('到车确认成功!');
                        this.$refs.tablePage.$refs.searchList.onSearchChange();
                    } else {
                        this.$message.error(res.data.messagesAsString);
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        _asternConfirmOne(row) {
            asternConfirmOne({
                models: [row],
                userId
            }).then(res => {
                if (res) {
                    if (res.data.data.success) {
                        this.$message.success('到车确认成功!');
                        this.$refs.tablePage.$refs.searchList.onSearchChange();
                    } else {
                        this.$message.error(res.data.data.messagesAsString);
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 列表双击
        _vehicleInformationQuery(etdoNo) {
            vehicleInformationQuery({ etdoNo }).then(res => {
                if (res && +res.code === 0 && res.data) {
                    this.infoData = res.data.data.etTasks;
                    this.inventoryData = res.data.data.items;
                }
            });
        },
        // 列表编辑保存
        _saveItem() {
            this.$refs.form.validate(async (valid) => {
                if (!valid) {
                    this.$message.error('请正确填写表单!');
                    return false;
                } else {
                    this.saveLoading = true;
                    this.ruleForm.shippingType === '00' && await this.getCarType(this.ruleForm.etdoEquipmentType);
                    this.ruleForm.etdoBesArriveDate = dayjs(this.ruleForm.etdoBesArriveDate).format('YYYY-MM-DD HH:mm:ss');
                    saveItem(this.ruleForm).then(res => {
                        if (res) {
                            this.handleEditClose(true);
                        }
                        this.saveLoading = false;
                    });
                }
            });
        },
        async  getCarType (etdoEquipmentType) {
            await getCarTypeApi({ carTypeParam: etdoEquipmentType }).then(async res => {
                if (res && +res.code === 0) {
                    if (res.data && res.data.messages[0] === '无车型') {
                        // 传入车牌号
                        await this.checkCarNameNetItem(this.ruleForm.etdoVehicleCard);
                    } else {
                        this.ruleForm.etdoNetFlag = 0;
                    }
                }
            });
        },
        async  checkCarNameNetItem (carTypeParam) {
            if (carTypeParam.length === 7) {
                carTypeParam = carTypeParam + '_2';
            } else if (carTypeParam.length === 8) {
                carTypeParam = carTypeParam + '_3';
            }
            await checkCarNameNetItemApi({ carTypeParam }).then(res => {
                if (res && +res.code === 0) {
                    if (res.data && res.data.data === 'yes') {
                        this.$message.warning('该车辆可通过北斗获取轨迹');
                        this.ruleForm.etdoNetFlag = 1;
                    } else {
                        this.$message.warning('该车辆不支持北斗轨迹获取，请要求司机全程打开直通宝');
                        this.ruleForm.etdoNetFlag = 0;
                    }
                }
            });
        },
        initRouter(isCache) {
            if (this.$route.query.etdoStatus) {
                this.initSearchInfo = {
                    etdoStatus: this.$route.query.etdoStatus.split(',')
                };
                this.$router.replace(this.$route.path);
                this.$nextTick(() => {
                    this.$refs.tablePage.$refs.searchList.onSearchChange();
                });
            }
            // if (isCache) {
            //     this.$refs.tablePage.$refs.searchList.onSearchChange();
            // }
        },
        formattingData(data) {
            const tempData = {
                createTimeFrom: data.createTime && data.createTime.length ? dayjs(data.createTime[0]).format('YYYY-MM-DD HH:mm:ss') : '',
                createTimeTo: data.createTime && data.createTime.length ? dayjs(data.createTime[1]).format('YYYY-MM-DD HH:mm:ss') : '',
                etdoBesArriveDateFrom: data.carTime && data.carTime.length ? dayjs(data.carTime[0]).format('YYYY-MM-DD HH:mm:ss') : '',
                etdoBesArriveDateTo: data.carTime && data.carTime.length ? dayjs(data.carTime[1]).format('YYYY-MM-DD HH:mm:ss') : '',
                ...data
            };
            delete tempData.createTime;
            delete tempData.carTime;
            return tempData;
        },
        // 查询结果
        searchChange(val) {
            val = this.formattingData(val);
            val.etdoStatusArray = val.etdoStatus.join();
            this.exportParams = { ...val, etdoStatusArray: val.etdoStatus };
            delete this.exportParams.etdoStatus;
            delete val.etdoStatus;
            this.searchData = val;
            this._getList();
        },
        pageChange(val) {
            this.currentPage = val;
            this._getList(val);
        },
        sizeChange(val) {
            this.pageSize = val;
            this._getList();
        },
        selectChange(data) {
            this.selectArray = data;
        },
        rowDBclick(row) {
            this._vehicleInformationQuery(row.etdoNo);
            this.isDetail = true;
        },
        back() {
            this.isDetail = false;
            this._getList();
        },
        // 关闭围栏备注弹窗
        closeFenceDialog () {
            this.isShowHandleReasonDialog = false;
            this._getList();
        },
        // 围栏校验备注回调函数
        handleSuccess ({ isFenceRemarked, data }) {
            if (this.handleType === 'depart') {
                this.depart({ isFenceRemarked });
            } else {
                this.toTheCar(data, isFenceRemarked);
            }
        },
        /**
         * description 手动发车前 进行电子围栏校验并增加提示 和 备注人工操作原因
         * @param {Boolean} isFenceRemarked (电子围栏校验)是否填写过人工操作原因
         */
        async depart ({ isFenceRemarked = false }) {
            if (!this.selectArray.length) {
                this.$message.error('请选中一条数据');
                return false;
            }
            for (const item of this.selectArray) {
                if (item.etdoStatus === ConstantsTES.DO_STATUS_CALL_CAR ||
                    item.etdoStatus === ConstantsTES.DO_STATUS_IN_THE_CAR ||
                    item.etdoStatus === ConstantsTES.DO_STATUS_LOADING) {
                    item.etdoDepartPerson = this.supplier.supplierNameCn;
                } else {
                    this.$message.error('发车单号' + item.etdoNo + '不是<已调车><已到车><已装货>状态，不能操作');
                    return false;
                }
                // if (!item.queuingFlag && (this.controlParams === 'ALL' || this.controlParams.indexOf(item.companyCode) > -1)) {
                //     this.$message.error('发车单' + item.etdoNo + '未匹配到车登记不能发车!');
                //     return false;
                // }
            }
            // 电子围栏校验
            if (!isFenceRemarked) {
                // 校验是否需要提示和备注原因
                const isNeedTooltip = await this.validateFence();
                if (!isNeedTooltip) {
                    this.isShowHandleReasonDialog = true;
                    this.handleType = 'depart';
                    this.componentsData = this.selectArray;
                    return;
                }
            }
            this._departConfirmBefore();
        },
        // 电子围栏校验，接口返回true则不需要备注人工操作原因，false则需要填写
        validateFence () {
            const params = {
                dispatchNos: this.selectArray.map(v => v.etdoNo)
            };
            return departCheckOperateReason(params).then(res => {
                if (res && +res.code === 0) {
                    return res.data.success;
                }
            }).catch(() => {
                return true;
            });
        },
        editBtn(row) {
            if (+row.etdoStatus === 0 || +row.etdoStatus === 10 || +row.etdoStatus === 25 || +row.etdoStatus === +ConstantsTES.DO_STATUS_IN_THE_CAR) {
                this.abledEtdoVehicleCard = false;
                this.abledEtdoMainDriver = false;
                this.abledEtdoBesArriveDate = +row.etdoStatus === 25;
                // this.abledEtdoMainDriverContactWay = false;
            } else {
                this.abledEtdoVehicleCard = true;
                this.abledEtdoMainDriver = true;
                this.abledEtdoBesArriveDate = true;
                // this.abledEtdoMainDriverContactWay = false;
            }
            this.formData.supplierCode = row.etdoCarrierCode;
            this.formData.routeNoList = [row.etdoLineCode];
            this.editVisible = true;
            this.ruleForm = Object.assign({}, this.ruleForm, row);
        },
        // 电子围栏校验，接口返回true则不需要备注人工操作原因，false则需要填写
        arriveValidateFence (data) {
            const params = {
                dispatchNo: data.etdoNo,
                type: 'arrive',
                etdsNo: '0' // 站点序号，"type":"arrive"固定传"0"，"type":"arrival"传实际站点序号
            };
            return arriveCheckOperateReason(params).then(res => {
                if (res && +res.code === 0) {
                    return res.data.success;
                }
            }).catch(() => {
                return true;
            });
        },
        /**
         * description 手动发车前 进行电子围栏校验并增加提示 和 备注人工操作原因
         * @param {Boolean} isFenceRemarked (电子围栏校验)是否填写过人工操作原因
         */
        async toTheCar(row, isFenceRemarked = false) {
            if (row.etdoStatus !== ConstantsTES.DO_STATUS_CALL_CAR) {
                this.$message.error('发车单号' + row.etdoNo + '不是已调车状态，不能进行到车确认操作！');
                return false;
            } else if (row.etdoProcurementChannel === ConstantsTES.TMS_EXPRESS) {
                this.$message.error('发车单号' + row.etdoNo + '采购渠道为快递，不能进行到车确认操作！');
                return false;
            }

            // 电子围栏校验
            if (!isFenceRemarked) {
                // 校验是否需要提示和备注原因
                const isNeedTooltip = await this.arriveValidateFence(row);
                if (!isNeedTooltip) {
                    this.isShowHandleReasonDialog = true;
                    this.handleType = 'arrive';
                    this.componentsData = row;
                    return;
                }
            }
            // 继续到车操作
            this._asternConfirm2(row);
        },
        handleEditClose(req) {
            this.editVisible = false;
            this.$refs.form.resetFields();
            this.ruleForm = {
                etdoNo: '', // 发车单号
                siteName: '', // 服务平台
                etdoStatus: '', // 发车单状态
                etdoCarrierName: '', // 承运商
                etdoVehicleCard: '', // 车牌号
                etdoEquipmentName: '', // 车型
                etdoMainDriver: '', // 司机
                etdoMainDriverContactWay: '', // 联系方式
                etdoBesArriveDate: '', // 要求到车时间
                etdoDispatcherName: '', // 调度人员
                etdoRemark: '', // 备注
                etdoTotalFee: '' // 总费用
            };
            if (req) {
                this._getList();
            }
        },
        handleEditChange() {
            this._saveItem();
        },
        getAdvanceValue(data) {
            this.ruleForm = Object.assign({}, this.ruleForm, data);
        },
        print(text) {
            if (!this.selectArray.length) {
                this.$message.error('请选中一条数据');
                return false;
            }
            if (this.selectArray.length > 1) {
                this.$message.error('只能选中一条数据');
                return false;
            }
            if ((text === 'distribution_order' || text === 'report_consignment_invoice') &&
                (this.controlParams === 'ALL' || this.controlParams.indexOf(this.selectArray[0].companyCode) > -1)) {
                if (!this.selectArray[0].queuingFlag) {
                    this.$message.error('发车单' + this.selectArray[0].etdoNo + '未匹配到车登记不能打印!');
                    return false;
                }
            }
            window.open(joinPath(configs.printPDFUrl, `/api-printer/preview?_ignore=true&_report=${text}&etdoNo=${this.selectArray[0].etdoNo}&userId=${userId}`));
        },
        /**
         * @description 整车异常发车原因 --行操作
         */
        abnormalReason (data) {
            // 校验是否可登记
            const isOk = isValidate(data);
            if (!isOk) return;
            this.registerVisible = true;
            this.componentsData = data;
        },
        /**
         * @description 整车异常发车原因 --批量操作
         */
        handleRegistration () {
            // 校验是否可登记
            const isOk = isValidate(this.selectArray);
            if (!isOk) return;
            this.registerVisible = true;
            this.componentsData = this.selectArray;
        },
        // 更新列表
        update () {
            this._getList();
        }
    }
};
</script>
